export default __webpack_public_path__ + "static/1.6-Headings-DONT-22b5e04a4624559ff856a85ccddef438.png";